// @flow

import React from 'react';
import { Field } from 'redux-form';
import { withRequired } from '../../validators';
import { breakpointsToArray } from '../../../../helpers';
import { Flex } from '../../../grid';
import {
  Label,
  FormRow,
  ReduxFormRadio,
} from '../../../form';
import { Text } from '../../../form/labelText';

type OwnProps = {
  label: string,
  name: string,
  options: Array<{|
    label: string,
    value: string,
  |}>,
  validate?: Array<Function>,
};

type Props = OwnProps;

const RadioField = ({
  label,
  name,
  options,
  validate,
}: Props) => (
  <FormRow>
    <>
      <Flex width={6 / 12}><Text>{label}</Text></Flex>
      <Flex width={breakpointsToArray({ default: 1, sm: 8 / 12 })}>
        {options.map(option => (
          <Label key={`${name}${option.label}`}>
            <Field
              name={name}
              component={ReduxFormRadio}
              type="radio"
              value={option.label}
              validate={validate}
            />
            {option.value}
          </Label>
        ))}
      </Flex>
    </>
  </FormRow>
);

RadioField.defaultProps = {
  validate: [],
};

export default withRequired<Props>(RadioField);
